// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"ab06d8b3","276":"2ec9cde5","726":"63e59fed"}[chunkId] + ".chunk.js";
};